import $ from 'jquery';
global.$ = global.jQuery = $;

// Import dependencies in correct order
import './config';
import './helpers';
import './popper';
import 'bootstrap';

// Import Menu before main.js
import Menu from './menu';
window.Menu = Menu; // Make Menu globally available

if (Menu && Menu.prototype && typeof Menu.prototype.manageScroll === 'function') {
    const originalManageScroll = Menu.prototype.manageScroll;

    Menu.prototype.manageScroll = function() {
        if (this._scrollbar == null || typeof this._scrollbar.destroy !== 'function') {
            this._scrollbar = null;
        }

        return originalManageScroll.call(this);
    };
}

import './main';
import 'boxicons';
import 'perfect-scrollbar';
import 'apexcharts';
import './dashboards-analytics';


$(window).on('load', function() {
    playPodcastBody();
});

function play_latest(id) {
    if (typeof window.playLatestEpisodeFromTile === 'function') {
        window.playLatestEpisodeFromTile(id);
        return;
    }

    let siteurl = window.location.origin;
    let csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    $.ajax({
        url: siteurl + '/getlatestepisode',
        method: 'post',
        async: false,
        data: 'podcast_id=' + id + '&_token=' + csrf_token,
        success: function(res) {
            console.log(res);
            var id = res.id
            playPosdcast(id, res)
        }
    })
}

function change_lct(title) {
    // alert(id);
    window.location.assign(`{{ url('podcast/${title}') }}`)
}

function playlivePosdcast(id) {
    console.log(id);
    sessionStorage.setItem('live_id', id);
    playPodcastBody();
}

var playPodcastBodyExecuted = false;
$(document).on('play pause', '#track', function(event) {

    if (playPodcastBodyExecuted) {
        if (event.type === 'pause') {
            sessionStorage.setItem("player_paused", "true");
        } else {
            sessionStorage.removeItem("player_paused");
        }
    }
    playPodcastBodyExecuted = true;

});

// function playPosdcast(url) {
//     localStorage.setItem('url', url);
//     $(".podcast_source").attr("src", url);
// }

// Make the function globally available
window.play_latest = play_latest;
window.change_lct = change_lct;
window.playlivePosdcast = playlivePosdcast;
// window.playPosdcast = playPosdcast;
